"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PortalCompatContextProvider: ()=>PortalCompatContextProvider,
    usePortalCompat: ()=>usePortalCompat
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const PortalCompatContext = /*#__PURE__*/ _react.createContext(undefined);
const portalCompatContextDefaultValue = ()=>()=>undefined;
const PortalCompatContextProvider = PortalCompatContext.Provider;
function usePortalCompat() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(PortalCompatContext)) !== null && _React_useContext !== void 0 ? _React_useContext : portalCompatContextDefaultValue;
} //# sourceMappingURL=PortalCompatContext.js.map

//# sourceMappingURL=PortalCompatContext.js.map